import Swiper from "swiper/bundle";

export default class Products {
  constructor(dom) {
    this.dom = dom;
    this.initProductOptsSlider();
    // this.initProductDetailsColorOpt();

    window.addEventListener("resize", () => this.resize());
  }

  initProductOptsSlider() {
    // console.log("OK");
    // declare Swiper.js .classes
    const sliders = document.querySelectorAll(".p_colours-slider");

    // declare navigation arrows classes
    // const mySliderPrev = document.querySelectorAll(".slider-prev");
    // const mySliderNext = document.querySelectorAll(".slider-next");
    // console.log(myCustomSlider);
    for (let [i, slider] of sliders.entries()) {
      slider.classList.add("p_colours-slider-" + i);

      var vidswiper = new Swiper(".p_colours-slider-" + i, {
        // Set sliders parameters
        slidesPerView: 5,
        // slidesPerGroup: 1,
        spaceBetween: 12,
        grabCursor: true,
        watchOverflow: true,
        // Navigation arrows
        // navigation: {
        //   nextEl: ".slider-next-" + i,
        //   prevEl: ".slider-prev-" + i,
        // },
      });
    }
  }
  resize() {
    // console.log("resize from Navigation.js");
  }
}
